import { FormConfig } from 'src/app/shared/models/dynamic.model';
import { HawbTransitPointPayload } from './hawb.model';

export interface Widget {
  id: number;
  title: string;
  value: string;
  extraClasses: string;
  iconName: string;
  name: string;
  controlName?: string;
}

export interface ShipmentGridColumnData {
  id: string;
  hawbExt: string;
  weight: string | number;
  dimensions: string;
  isInputRow?: boolean;
  checked?: boolean;
  shipper: string;
  consignee: string;
}

export interface ComponentMapping {
  title: string;
  componentType: any;
}

export const miscellaneousFormfieldsConfig: FormConfig = {
  fields: [
    {
      id: 'tareWeight',
      type: 'input',
      label: 'Tare Weight(lb)',
    },
  ],
};

export interface IBagDeleteResult {
  statusCode: number;
  message: string;
  data: any;
  code: number;
  statusCodes: number;
  status?: number;
}

import { EntityPermissionFields } from 'src/app/shared/models/permission-flags.model';

export interface bagColumnData {
  bagId: number;
  date: string;
  weight: number;
  packagingType: string;
  noofPieces: number;
  checked?: boolean;
  bagExt?: string;
  /** Present on summary grid rows from API */
  noofShipments?: number;
  manifestNo?: string;
  isAllowedToEdit?: EntityPermissionFields['isAllowedToEdit'];
}

export interface TableColumns {
  key: string;
  label: string;
  value: string;
  isSelected: boolean;
  defaultView: boolean;
}

export interface FieldOption {
  label: string;
  value: string;
}

export interface IDropdownResponse {
  id: number;
  name: string;
}

export interface IBagEventData {
  id: string;
  date: string;
  time: string;
  zone: string;
  name: string;
  info: string;
}

/* Bag Information Page */
export interface IBagInformationData {
  bagId: number;
  bagNumber: string;
  hawbId: number;
  origin: string;
  destination: string;
  packagingType: number;
  manifestNumber: string;
  flightNumber: string;
  description: string;
  notes: IBagNotesData;
  attachmentList: IBagAttachmentData[];
  miscellaneous: IBagMiscellaneousData;
  eventsList: IBagEventData[];
  shipmentList: IBagLinkedShipmentData[];
}

export interface IBagNotesData {
  ibc: IBagNotesDetails[];
  customer: IBagNotesDetails[];
}

export interface IBagNotesDetails {
  id: string;
  comments: string;
  action: string;
  userId: number;
  userName: string;
}

export interface IBagAttachmentData {
  id: any;
  type: string;
  fileName: string;
  signedUrl: string;
  action: string;
  attachmentTypeValuId: string;
  isFromScreen?: string;
}

export interface IBagMiscellaneousData {
  tareWeight?: string;
}

export interface IBagMiscellaneousStateModel {
  miscellaneous: IBagMiscellaneousData;
}

export interface IBagLinkedShipmentData {
  id: string;
  action: string;
  bag?: any;
}

/* Bag Information Page - Get Piece Data by piece ext */
export interface IBagPieceInformationSuccessResponse {
  statusCode: number;
  message: string;
  data: IShipmentList;
  status?: number;
  conditionCheck?: string;
}

export interface IShipmentList {
  shipmentList: IBagShipmentListData[];
}

export interface IShipmentStateModel {
  shipmentList: IBagShipmentData[];
}

export interface IBagShipmentListData {
  shipment: IBagShipmentData;
  notes: IBagNotesData;
  attachments: IBagAttachmentData[];
  id?: any;
  shipmentBag?: any;
  source?: any;
}

export interface IBagShipmentData {
  id: string;

  weight: string;
  dimLength: string;
  dimWidth: string;
  dimHeight: string;
  hawbExt: string;

  isInputRow: boolean;
  dimensions?: string;
  source?: string;
  hawbStatus: string;
}

export interface IBagLinkPieces {
  id: string;
  action: string;
}

export interface bagInfoResetStateModel {
  data: IBagInformationData;
}

export interface BagSearchPayload {
  bagExt: string;
  originId: string;
  destinationId: string;
  packagingType: string;
  manifestNumber: string;
  flightNumber: string;
  searchType: string;
  paging: {
    fromIndex: number;
    toIndex: number;
    sortingOrder: string;
    sortingField: string;
  };
  data?: any;
}

export interface DropdownList {
  id: number;
  name: string;
}

export interface IDropdownListResult {
  statusCode: number;
  message: string;
  data: DropdownList[];
}

export interface IBagInformationSearchPayload {
  bagId?: number;
  bagExt: any;
  searchType: string;
  paging: {
    fromIndex: number;
    toIndex: number;
    sortingOrder?: string;
    sortingField?: string;
  };
}

export interface bagInformationListData {
  totalRecords: number;
  sortingOrder: string;
  sortingField: string;
  bag: IBagInformationData[];
}

export interface IBagInformationListResult {
  statusCode: number;
  message: string;
  data: bagInformationListData;
}

export const defaultNotesData: IBagNotesData = {
  ibc: [],
  customer: [],
};

export const defaultIBagShipmentData: any = {
  id: '',
  hawbExt: '',
  weight: '',
  dimLength: '',
  dimWidth: '',
  dimHeight: '',
  hawbId: '',
  isInputRow: false,
  dimensions: '',
  notes: defaultNotesData,
  action: '',
  attachments: [],
  hawbStatus: '',
};

export const defaultBagMiscellaneousData: IBagMiscellaneousData = {
  tareWeight: '',
};

export const defaultBagInformation: IBagInformationData = {
  bagId: 0,
  bagNumber: '',
  hawbId: 0,
  origin: '',
  destination: '',
  packagingType: 0,
  manifestNumber: '',
  flightNumber: '',
  description: '',
  notes: defaultNotesData,
  attachmentList: [],
  miscellaneous: defaultBagMiscellaneousData,
  shipmentList: [],
  eventsList: [],
};

export interface IBagInfoData {
  bagId: number;
  bagNumber: string;
  hawbId: number;
  origin: string;
  destination: string;
  packagingType: number;
  manifestNumber: string;
  flightNumber: string;
  description: string;
  airline: string;
}

export const defaultBagInfo: IBagInfoData = {
  bagId: 0,
  bagNumber: '',
  hawbId: 0,
  origin: '',
  destination: '',
  packagingType: 0,
  manifestNumber: '',
  flightNumber: '',
  description: '',
  airline: '',
};

export const deafultShipmentList: IBagShipmentListData = {
  shipment: defaultIBagShipmentData,
  notes: defaultNotesData,
  attachments: [],
};

export interface IBagDeleteResult {
  statusCode: number;
  message: string;
  data: any;
  code: number;
  statusCodes: number;
  status?: number;
}

export interface PieceBagList {
  id: string;
  pieceExt: string;
  pieceNumber: string;
  noofpieces: string;
  barcode: string;
  bag: string;
  weight: string;
  value: string;
  dimLength: string;
  dimWidth: string;
  dimHeight: string;
  packagingType: string;
  hawbId: string;
  agent: string;
  serviceType: string;
  customerId: string;
  customerGroupId: string;
  isInputRow?: boolean;
  dimensions?: string;
  notes: IBagNotesData;
  action: string;
  attachments: IBagAttachmentData;
  piece?: {};
  tempPieceId: number;
}

export interface BagDropdownList {
  origins: IDropdownResponse[];
  destinations: IDropdownResponse[];
  attachmentType: IDropdownResponse[];
  customerIdData: IDropdownResponse[];
  airlineCodeData: IDropdownResponse[];
}

export type IncomingContainerFlowMode =
  | 'single_final_destination'
  | 'multi_final_destination';

/**
 * Route data returned by the backend for bags that have already been through
 * a prior gateway leg (multi-TP journey). When present the routing step
 * pre-populates from this instead of asking the user to re-select.
 */
export interface IBagGatewayExistingRoute {
  mode: 'configure_own' | 'preconfigured';
  routeId: number | null;
  transitPoints: HawbTransitPointPayload[];
}

export interface IBagGatewayFinalDestinationGroup {
  finalDestinationFacId: number;
  finalDestinationName: string;
  shipmentCount: number;
  clearedCount: number;
  heldCount: number;
  clearedHawbIds: number[];
  heldHawbIds: number[];
  routingBlocked: boolean;
  /** Present when the incoming bag already has a configured route (2nd+ leg). */
  existingRoute?: IBagGatewayExistingRoute | null;
}

export interface IBagGatewayGridData {
  incomingBagDestinationId: number;
  incomingBagOriginId: number;
  incomingShipmentInfo: IIncomingBagShipmentInfo[];
  totalShipmentCount: number;
  destinationName: string;
  outgoingBagDestinationName: string;
  outgoingBagDestinationId: number;
  flowMode?: IncomingContainerFlowMode;
  finalDestinationGroups?: IBagGatewayFinalDestinationGroup[];
  canProceedFromStep1?: boolean;
  currentFacilityId?: number | null;
  incomingBagExt?: string;
  incomingManifestNumber?: string;
  cbpClearance?: {
    requiresCbpHeldBlock?: boolean;
    heldPieceCount?: number;
    requiresCbpAcknowledgement?: boolean;
  };
  partiallyHeldIdsCount?: number;
  remainingEligibleCount?: number;
  partialHeldGatewayMessage?: string | null;
  heldHawbIds?: number[];
  eligibleHawbIds?: number[];
}

export type BagGatewayOutboundAction = 'create_new' | 'existing';

export interface IBagGatewayRoutePayload {
  mode: 'configure_own' | 'preconfigured';
  routeId: number | null;
  transitPoints: Record<string, unknown>[];
}

export interface IBagGatewayOutboundAssignmentPayload {
  currentTransitOriginId: number;
  currentTransitDestinationId: number;
  outgoingBag: string;
  outgoingBagAction: BagGatewayOutboundAction;
  outgoingManifest: string;
  outgoingManifestAction: BagGatewayOutboundAction;
  hawbIds: number[];
  route: IBagGatewayRoutePayload;
}

export interface IBagGatewayCompleteRequest {
  scanIncomingBag: string;
  outboundAssignments: IBagGatewayOutboundAssignmentPayload[];
}

export interface IIncomingBagShipmentInfo {
  shipper: string;
  noOfShipments: number;
  incomingManifest: string;
}

export interface BagGatewayGridRow extends IIncomingBagShipmentInfo {
  id: number;
}

/** Criteria for `PaginatedDataService` on Bag summary (basic vs advance). */
export type BagListSearchCriteria =
  | {
      variant: 'basic';
      searchText: string;
      ids?: number[];
      isMasterChildRequired?: boolean;
    }
  | { variant: 'advance' };
